export default "__VITE_ASSET__CbE3Qba9__"